module.exports = __webpack_public_path__ + "img/ol.4bc32138.png";